
import { User } from '@/contexts/auth/types';

/**
 * Checks if an organizer's profile is complete enough to proceed
 * @param user The user object to check
 * @returns Boolean indicating if the profile is complete
 */
export const isOrganizerProfileComplete = (user: User | null): boolean => {
  if (!user) return false;
  
  const { userProfile } = user;
  
  // Check for essential profile information
  const hasName = Boolean(userProfile?.name?.firstName && userProfile?.name?.lastName);
  const hasContactPhone = Boolean(userProfile?.contactPhone);
  
  // Check for company info (at least company name)
  const hasCompanyInfo = Boolean(userProfile?.companyInfo?.name);
  
  return Boolean(hasName && (hasContactPhone || hasCompanyInfo));
};
